module.exports = __webpack_public_path__ + "static/media/pg15.e3f0a5cd.jpg";